/**
 * Convert hex color to RGB components
 * @param hex - Hex color string (e.g., "#FF5733")
 * @returns RGB object with r, g, b values (0-255)
 */
export function hexToRgb(hex: string): { r: number; g: number; b: number } {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
    : { r: 0, g: 0, b: 0 }
}

/**
 * Convert hex color to PixiJS numeric color
 * @param hex - Hex color string (e.g., "#FF5733")
 * @returns Numeric color value for PixiJS
 */
export function hexToPixiColor(hex: string): number {
  return parseInt(hex.replace('#', '0x'))
}

/**
 * Add alpha transparency to hex color
 * @param hex - Hex color string
 * @param alpha - Alpha value (0-1)
 * @returns RGBA color string
 */
export function hexToRgba(hex: string, alpha: number): string {
  const rgb = hexToRgb(hex)
  return `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${alpha})`
}
